import { FC } from 'react';
import { Datagrid, List, TextField } from 'react-admin';
import HardwareCompatibilityField from './HardwareCompatibilityField';

export const SoftwareComponentList: FC = () => {
  return (
    <List>
      <Datagrid bulkActionButtons={false} rowClick="show">
        <TextField source="name" />
        <HardwareCompatibilityField label="resources.software_components.fields.hardware_ids" />
        <TextField source="path" emptyText="-" />
        <TextField source="build_project_name" emptyText="-" />
      </Datagrid>
    </List>
  );
};
